import { DispatcherEvent } from '@carvana/merch-native';
import { useCallback, useContext } from 'react';
import CtaType from '~/constants/ctaType';
import { useIsNative } from '~/context/common/DeviceContext';
import ModalContext from '~/context/vdp/ModalContext';
import useCtaButtonState from '~/hooks/vdp/selectors/useCtaButtonState';
import { useEventPayload } from '~/hooks/vdp/selectors/useVehicleDetailsForNative';
import sendPurchaseMessageToNative from './sendPurchaseMessageToNative';
import useGetStarted from './useGetStarted';
import usePreOrder from './usePreOrder';

const dummyFunction = () => {};

function useClickHandler(): () => void {
  const isNative = useIsNative();
  const { setLockTimerModalOpen } = useContext(ModalContext);
  const { stockNumber, type } = useCtaButtonState();
  const eventPayload = useEventPayload();

  const getStarted = useGetStarted(stockNumber);
  const preOrder = usePreOrder();

  const continuePurchase = useCallback(() => {
    if (isNative) {
      sendPurchaseMessageToNative(
        DispatcherEvent.ContinuePurchase,
        eventPayload
      );
    } else {
      window.location.href = `/purchase/dashboard?stock-number=${stockNumber}`;
    }
  }, [eventPayload, isNative, stockNumber]);

  const notifyMe = useCallback(() => {
    setLockTimerModalOpen(true);
  }, [setLockTimerModalOpen]);

  switch (type) {
    case CtaType.ContinuePurchase:
      return continuePurchase;
    case CtaType.Default:
      return dummyFunction;
    case CtaType.GetStarted:
      return getStarted;
    case CtaType.Loader:
      return dummyFunction;
    case CtaType.NotifyMe:
      return notifyMe;
    case CtaType.Reservable:
      return preOrder;
    default:
      return dummyFunction;
  }
}

function useButtonHandler(onClick: () => void = dummyFunction) {
  const { isDisabled } = useCtaButtonState();
  const handleClick = useClickHandler();

  const buttonHandler = useCallback(() => {
    onClick();
    handleClick();
  }, [handleClick, onClick]);

  return isDisabled ? dummyFunction : buttonHandler;
}

export default useButtonHandler;
